// extracted by mini-css-extract-plugin
export var label = "_i3-2";
export var slideContainer = "_i3-0";
export var slider = "_i3-1";